// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"2ad73013","413":"80d868b3","453":"c49366f1","454":"9f7ec71e","478":"794919ad","556":"55c82ed0","805":"dcd265e8","901":"8aaf1cb3"}[chunkId] + ".chunk.js";
};